import type {
  FetchInitiativeDefaultAction,
  FetchInitiativeForIdAction,
  FetchInitiativeForIdFulfilledAction,
  FetchInitiativeForIdRejectedAction,
  FetchInitiativeFulfilledAction,
  FetchInitiativeRejectedAction,
} from "entities/initiatives/actionTypes";
import { InitiativesType } from "entities/initiatives/actionTypes";

export const fetchInitiativesForTopic = (
  payload: FetchInitiativeDefaultAction["payload"],
): FetchInitiativeDefaultAction => ({
  type: InitiativesType.FETCH_FOR_TOPIC,
  payload,
});

export const fetchInitiativesForTopicSuccess = (
  payload: FetchInitiativeFulfilledAction["payload"],
  meta: FetchInitiativeFulfilledAction["meta"],
): FetchInitiativeFulfilledAction => ({
  type: InitiativesType.FETCH_FOR_TOPIC_SUCCESS,
  payload,
  meta,
});

export const fetchInitiativesForTopicFailure = (
  meta: FetchInitiativeRejectedAction["meta"],
): FetchInitiativeRejectedAction => ({ type: InitiativesType.FETCH_FOR_TOPIC_FAILURE, meta });

export const fetchInitiativeById = (meta: FetchInitiativeForIdAction["meta"]): FetchInitiativeForIdAction => ({
  type: InitiativesType.FETCH_FOR_ID,
  meta,
});

export const fetchInitiativeByIdSuccessful = (
  payload: FetchInitiativeForIdFulfilledAction["payload"],
  meta: FetchInitiativeForIdFulfilledAction["meta"],
): FetchInitiativeForIdFulfilledAction => ({
  type: InitiativesType.FETCH_FOR_ID_SUCCESS,
  payload,
  meta,
});

export const fetchInitiativeByIdFailure = (
  meta: FetchInitiativeForIdRejectedAction["meta"],
): FetchInitiativeForIdRejectedAction => ({ type: InitiativesType.FETCH_FOR_ID_FAILURE, meta });
